// extracted by mini-css-extract-plugin
export default {"title":"title_title__KrurI","bold":"title_bold__7U2o6","secondPartTitle":"title_secondPartTitle__I1fjq","isSmall":"title_isSmall__Xyzj5"};